import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "layouts/complaints/complaints.css";
import "assets/theme/admin_form.css";

const AddComplaints = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [receipt, setReceipt] = useState(null);
  const [villages, setVillages] = useState([]);
  const [sources, setSources] = useState([]);
  const [wards, setWards] = useState([]);
  const [errors, setErrors] = useState({});

  const initialState = {
    full_name: "",
    mobile: "",
    aadhar_no: "",
    address: "",
    ward_id: "",
    title: "",
    description: "",
    department_id: "",
    category_id: "",
    priority: "MEDIUM",
    location: "",
    source_id: "",
    image: null,
    village_id: "",
  };

  const [formData, setFormData] = useState(initialState);

  const loadDropdowns = async () => {
    try {
      const departmentsData = await apiFetch("super_admin/list_department");
      setDepartments(departmentsData.departments || departmentsData);
    } catch (error) {
      alert(error.message);
    }
  };

  const loadVillages = async () => {
    try {
      const res = await apiFetch("leader_admin/get_villages_by_ward_id");
      setVillages(res.data || []);
    } catch (error) {
      alert(error.message);
    }
  };

  const loadSources = async () => {
    try {
      const sourcesData = await apiFetch("super_admin/list_source");
      setSources(sourcesData.sources || sourcesData);
    } catch (error) {
      alert(error.message);
    }
  };

  const loadWards = async () => {
    try {
      const wardsData = await apiFetch("leader_admin/get_ward_by_user_id");
      setWards(wardsData.ward ? [wardsData.ward] : []);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleDepartmentChange = async (e) => {
    const departmentId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      department_id: departmentId,
      category_id: "",
    }));
    if (errors.department_id) setErrors((prev) => ({ ...prev, department_id: "" }));

    setCategories([]);
    if (!departmentId) return;

    try {
      const response = await apiFetch(
        `super_admin/get_category_by_department_id?department_id=${departmentId}`
      );
      setCategories(response.categories || response);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData((prev) => ({ ...prev, image: files[0] }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.department_id) {
      newErrors.department_id = "कृपया विभाग निवडा (Please select a department)";
    }
    if (!formData.category_id) {
      newErrors.category_id = "कृपया वर्ग निवडा (Please select a category)";
    }
    if (!formData.source_id) {
      newErrors.source_id = "कृपया स्रोत निवडा (Please select a source)";
    }
    if (!formData.village_id) {
      newErrors.village_id = "कृपया वार्ड क्षेत्र निवडा (Please select ward area)";
    }
    if (!formData.full_name.trim()) {
      newErrors.full_name = "पूर्ण नाव आवश्यक आहे (Full Name is required)";
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "मोबाईल क्रमांक आवश्यक आहे (Mobile Number is required)";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "मोबाईल क्रमांक १० अंकी असावा (Mobile number must be 10 digits)";
    }
    if (!formData.title.trim()) {
      newErrors.title = "तक्रारीचे शीर्षक आवश्यक आहे (Title is required)";
    }
    if (!formData.description.trim()) {
      newErrors.description = "सविस्तर माहिती आवश्यक आहे (Description is required)";
    }
    if (!formData.location.trim()) {
      newErrors.location = "तक्रारीचे ठिकाण आवश्यक आहे (Location is required)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      let imageBase64 = null;

      if (formData.image) {
        imageBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(formData.image);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      }

      const payload = {
        ...formData,
        image: imageBase64,
      };

      const response = await apiFetch("leader_admin/add_complaint", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      setReceipt(response.receipt);
      alert("तक्रार यशस्वीरीत्या नोंदवली गेली (Complaint submitted successfully)");
      setFormData(initialState);
      setCategories([]);
      setErrors({});
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDropdowns();
    loadSources();
    loadWards();
    loadVillages();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                📋 ऑफलाइन तक्रार नोंदणी (Add Offline Complaint)
              </h4>
              <small className="text-white-50">
                Register complaints submitted during in-person meetings
              </small>
            </div>
          </div>

          <Link to="/all_complaints" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            तक्रारी पहा (View Complaints)
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                <div className="col-12">
                  <div className="bg-light p-2 rounded mb-2">
                    <h6 className="fw-bold text-primary mb-0" style={{ fontSize: "0.95rem" }}>नागरिक माहिती (Citizen Information)</h6>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">वार्ड (Ward)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ward"
                    disabled
                    value={
                      wards.length > 0
                        ? `${wards[0].ward_name}, Ward No (${wards[0].ward_number})`
                        : "लोड होत आहे... (Loading...)"
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">जिल्हा (District)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="district"
                    disabled
                    value={wards.length > 0 ? wards[0].district_name : "लोड होत आहे... (Loading...)"}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    विभाग (Department) <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.department_id ? "is-invalid" : ""}`}
                    name="department_id"
                    value={formData.department_id}
                    onChange={handleDepartmentChange}
                  >
                    <option value="">विभाग निवडा (Select Department)</option>
                    {departments.map((dept) => (
                      <option key={dept.department_id} value={dept.department_id}>
                        {dept.department_name}
                      </option>
                    ))}
                  </select>
                  {errors.department_id && (
                    <small className="text-danger d-block mt-1">{errors.department_id}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    वर्ग (Category) <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.category_id ? "is-invalid" : ""}`}
                    name="category_id"
                    value={formData.category_id}
                    onChange={handleChange}
                    disabled={!formData.department_id}
                  >
                    <option value="">
                      {!formData.department_id
                        ? "प्रथम विभाग निवडा (Select Department First)"
                        : "वर्ग निवडा (Select Category)"}
                    </option>
                    {categories.map((cat) => (
                      <option key={cat.category_id} value={cat.category_id}>
                        {cat.category_name}
                      </option>
                    ))}
                  </select>
                  {errors.category_id && (
                    <small className="text-danger d-block mt-1">{errors.category_id}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    स्रोत (Source) <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.source_id ? "is-invalid" : ""}`}
                    name="source_id"
                    value={formData.source_id}
                    onChange={handleChange}
                  >
                    <option value="">स्रोत निवडा (Select Source)</option>
                    {sources.map((source) => (
                      <option key={source.source_id} value={source.source_id}>
                        {source.source_name}
                      </option>
                    ))}
                  </select>
                  {errors.source_id && (
                    <small className="text-danger d-block mt-1">{errors.source_id}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    वार्ड क्षेत्र (Ward Area) <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.village_id ? "is-invalid" : ""}`}
                    name="village_id"
                    value={formData.village_id}
                    onChange={handleChange}
                  >
                    <option value="">Area निवडा (Select Area)</option>
                    {villages.map((village) => (
                      <option key={village.village_id} value={village.village_id}>
                        {village.village_name}
                      </option>
                    ))}
                  </select>
                  {errors.village_id && (
                    <small className="text-danger d-block mt-1">{errors.village_id}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    पूर्ण नाव (Full Name) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                  />
                  {errors.full_name && (
                    <small className="text-danger d-block mt-1">{errors.full_name}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    मोबाईल क्रमांक (Mobile Number) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="10-digit mobile number"
                  />
                  {errors.mobile && (
                    <small className="text-danger d-block mt-1">{errors.mobile}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    आधार क्रमांक (Aadhar Number) (पर्यायी / Optional)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="aadhar_no"
                    value={formData.aadhar_no}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">राहण्याचा पत्ता (Residential Address)</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="bg-light p-2 rounded mb-2">
                    <h6 className="fw-bold text-primary mb-0" style={{ fontSize: "0.95rem" }}>तक्रारीचा तपशील (Complaint Details)</h6>
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">
                    तक्रारीचे शीर्षक (Complaint Title) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.title ? "is-invalid" : ""}`}
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                  {errors.title && (
                    <small className="text-danger d-block mt-1">{errors.title}</small>
                  )}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">
                    सविस्तर माहिती (Detailed Description) <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className={`form-control ${errors.description ? "is-invalid" : ""}`}
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                  {errors.description && (
                    <small className="text-danger d-block mt-1">{errors.description}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    तक्रारीचे ठिकाण (Complaint Location) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.location ? "is-invalid" : ""}`}
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                  />
                  {errors.location && (
                    <small className="text-danger d-block mt-1">{errors.location}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    पुरावा छायाचित्र (Supporting Image) (पर्यायी / Optional)
                  </label>
                  <input type="file" className="form-control" name="image" onChange={handleChange} />
                </div>
              </div>

              <div className="mt-4 text-end">
                <button className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "सादर करत आहे... (Submitting...)" : "तक्रार सादर करा (Submit Complaint)"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {receipt && (
        <>
          <div className="text-center mt-4">
            <button className="btn btn-success px-4" onClick={() => window.print()} style={{ fontSize: "0.85rem" }}>
              पावती प्रिंट करा (Print Receipt)
            </button>
          </div>

          <div className="receipt-print">
            <div className="receipt-center receipt-bold" style={{ fontSize: "12px" }}>
              जनता दरबार (JANTA DARBAR)
            </div>
            <div className="receipt-center">तक्रार पावती (Complaint Receipt)</div>
            <div className="receipt-line"></div>
            <div>टोकन (Token): {receipt.complaint_token}</div>
            <div>दिनांक (Date): {new Date().toLocaleDateString("mr-IN")}</div>
            <div className="receipt-line"></div>
            <div>नाव (Name): {receipt.citizen_name || formData.full_name}</div>
            <div>मोबाईल (Mobile): {receipt.mobile}</div>
            <div className="receipt-line"></div>
            <div>वार्ड (Ward): {receipt.ward_name}</div>
            <div>वार्ड क्र. (Ward No.): {receipt.ward_number}</div>
            <div>नेते (Leader): {receipt.leader_name}</div>
            <div className="receipt-line"></div>
            <div className="receipt-center">
              धन्यवाद (Thank You)
              <br />
              पुन्हा भेट द्या (Visit Again)
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default AddComplaints;
